/// <reference types="./remote.d.mts" />
import { Ok, Error, CustomType as $CustomType } from "../gleam.mjs";

export class NotLoaded extends $CustomType {}

export class Loading extends $CustomType {}

export class Loaded extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Errored extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export function read(remote) {
  if (remote instanceof NotLoaded) {
    return new Error(undefined);
  } else if (remote instanceof Loading) {
    return new Error(undefined);
  } else if (remote instanceof Loaded) {
    let content = remote[0];
    return new Ok(content);
  } else {
    return new Error(undefined);
  }
}

export function map(remote, mapper) {
  if (remote instanceof NotLoaded) {
    return new NotLoaded();
  } else if (remote instanceof Loading) {
    return new Loading();
  } else if (remote instanceof Loaded) {
    let l = remote[0];
    return new Loaded(mapper(l));
  } else {
    let e = remote[0];
    return new Errored(e);
  }
}
